import projects from '../../data/projects.json';
import type { AppDef } from '../../types/window';
import type { Project } from '../../types/content';
import { el, button } from './dom';
import { iconUrl } from '../icons';

const catalog = projects as Project[];

export const projectsApp: AppDef = {
  appId: 'projects',
  title: 'Projects',
  icon: 'folder',
  defaultSize: { w: 480, h: 320 },
  singleton: true,
  mount(root, ctx) {
    const wrap = el('div', { className: 'app-stack' });
    wrap.append(el('h1', { text: 'Projects' }));
    const visible = catalog.filter((p) => p.visibility === 'public');
    if (!visible.length) wrap.append(el('p', { text: 'Nothing public yet.' }));
    for (const p of visible) {
      const row = el('div', { className: 'app-row' });
      const left = el('div');
      left.style.display = 'flex';
      left.style.gap = '8px';
      left.style.alignItems = 'center';
      const img = el('img', { className: 'icon-32', attrs: { alt: '' } });
      img.src = iconUrl(p.icon);
      const text = el('div');
      text.append(el('strong', { text: p.title }), el('div', { text: p.summary }));
      left.append(img, text);
      const actions = el('div');
      actions.append(el('span', { className: 'chip', text: p.status }));
      if (p.appId) {
        actions.append(
          button('Open', () => ctx.openApp(p.appId!, p.payload as Record<string, unknown> | undefined)),
        );
      }
      row.append(left, actions);
      wrap.append(row);
    }
    root.replaceChildren(wrap);
    return () => root.replaceChildren();
  },
};
